// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import SupportView from "../../components/support";

const Support = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <SupportView />
    </Main>
  </>
);

export default Support;
